import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import promisify from 'util.promisify';
import { connect } from 'react-redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';
import { UserType } from '../validation';
import userSlice from '../collections/user';
import { LOGIN_TIMEOUT } from '../constants/general';
import errorCodes from '../constants/errorCodes';
import i18n from '../i18n';
import isAuthEnabled from '../helpers/authHelpers';

class PrivateRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logged: !isAuthEnabled(),
      errorCode: null
    };
  }

  componentDidMount = () => {
    if (isAuthEnabled()) {
      this.tryLogin(new Date().getTime() + LOGIN_TIMEOUT)
    }
  };

  tryLogin = (timeout) => {
    if (window.ssense) {
      this.login();
    } else {
      setTimeout(() => {
        if (window.ssense) {
          this.login();
        } else if (new Date().getTime() > timeout) {
          console.error('could not load the authentification script');
        } else {
          this.tryLogin(timeout);
        }
      }, 1);
    }
  };

  login = () => {
    const { logged } = this.props;
    return promisify(window.ssense.authenticate.bind(window.ssense))({
      app: 'ui-sstudio',
      with: 'user',
    })
      .then((res) => {
        logged(res.user);
        return this.setState({ logged: true });
      })
      .catch((e) => {
        if (e.response && errorCodes[e.response.status]) {
          this.setState({ errorCode: errorCodes[e.response.status] })
        }
        console.error(e);
      });
  };

  checkRouteFeatureFlag = route => {
    const { flags } = this.props;
    return !route.featureFlag || flags[route.featureFlag]
  }

  checkRouteScope(route) {
    const { user } = this.props;
    return !route.scopes || (user.scopes && route.scopes.some((role) => user.scopes.includes(role)));
  }

  render() {
    const { route } = this.props;
    const { logged, errorCode } = this.state;

    if (errorCode) {
      return (
        <div>
          {i18n.t(`loginError:${errorCode}`)}
        </div>
      );
    }
    if (!logged) {
      return (
        <div>
          {i18n.t('login')}
          ...
        </div>
      );
    }
    if (!this.checkRouteFeatureFlag(route)) {
      return (
        <div>
          {i18n.t('featureNotEnabled')}
        </div>
      )
    }
    if (!this.checkRouteScope(route)) {
      if (route.path === '/') {
        return <Redirect to='/me' />
      }
      return (
        <div>
          {i18n.t('forbidden')}
        </div>
      );
    }
    return <Route path={route.path} component={route.component} />;
  }
}

const mapDispatchToProps = { logged: userSlice.actions.logged };

const mapStateToProps = (state) => ({
  user: state.user,
});

PrivateRoute.propTypes = {
  flags: PropTypes.objectOf(PropTypes.bool).isRequired,
  route: PropTypes.shape({
    path: PropTypes.string.isRequired,
    component: PropTypes.elementType.isRequired,
    scopes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  logged: PropTypes.func.isRequired,
  user: UserType.isRequired
};

export { PrivateRoute as PrivateRouteNoConnect }
export default withLDConsumer()(connect(mapStateToProps, mapDispatchToProps)(PrivateRoute));
